import { Box, Grid, useTheme } from "@mui/material";
import React, { useState, useContext, useEffect } from "react";

import { UserTypeContext } from "../../context/userStatus";
import { userService } from "../../services/auth";
import {
  isExpandMode,
  isPersonalMode,
  setAccountBlocked,
  setToturialStepGlobal,
  setUserObject,
  setUserProducts,
  setVisibleTutorialGloabl,
} from "../../store/actions/userTypeAction";

import useWidth from "../../utils/useWidth";
import { contactsService } from "../../services/contactsService";
import { ContactsContext } from "../../context/userIContacts";
import {
  setAllContacts,
  setGroupContacts,
} from "../../store/actions/contactsActions";

import { useLocation, useNavigate } from "react-router-dom";
import TrackerSnackbar from "./TrackerSnakbar";
import TracingLoader from "./TrackingLoader";
import DesktopView from "./desktopView";
import TrackingView from "../tracker";
import { setArchiveMode } from "../../store/actions/trackerAction";
import { TrackingContext } from "../../context/userTracking";
import LimitReachedPopup from "./limitReachedModal";
import FullpageLoader from "../../components/fullPageLoader";
import TutorialModal from "./tutorialModals";
import FinalAnimation from "../improvements/finalAnimation";
import palette from "../../theme/palette";
import useNotifications from "../../components/DayCompleteSnackBar";
import MobileLinkModal from "./mobileLinkModal";
import PaymentPlanInfo, { PAYMENT_STATUS } from "./paymentplaninfo";

const TrackingViewNew = () => {
  const { state: IUserTypeState, dispatch: userTypeDispatch } =
    useContext(UserTypeContext);
  const { dispatch: trackingDispatch } =
    useContext(TrackingContext);
  const isDarkMode = useTheme().palette.mode === "dark" || IUserTypeState.isDarkMode
  // const [isExpandMode, setIsExpandMode] = useState(false);
  // const [ispersonalMode, setIsPersonalMode] = useState(false);
  const [userDetailsLoaded, setUserDetailsLoaded] = useState(false);
  const [visibleTutorial, setVisibleTutorial] = useState(false);
  const [visiblePaymentFree, setVisiblePaymentFree] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(PAYMENT_STATUS.ONBOARD);
  const [subscriptionPlanEnded, setSubscriptionPlanEnded] = useState(false);
  const [subscriptionPlanEndedBilling, setSubscriptionPlanEndedBilling] = useState(false);
  const [visibleMobileLoginModal, setVisibleMobileLoginModal] = useState(false);
  const [queryObject, setQueyrObject] = useState<any>({})
  const [showFinalAnimation, setShowAnimation] = useState(
    localStorage.getItem("showAnimation") === "true"
  );
  const [isFromOnboard, setIsFromOnboard] = useState(
    localStorage.getItem("showAnimation") === "true"
  );
  const { dispatch: contactsDispatch } =
    useContext(ContactsContext);
  const { Notification } = useNotifications();

  let userValues = JSON.parse(localStorage.getItem("userValues"));
  let location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const viewType = localStorage.getItem("viewType");
    const mode = localStorage.getItem("mode");
    if (viewType === "expand") {
      userTypeDispatch(isExpandMode(true));
    }
    if (mode === "personal") {
      userTypeDispatch(isPersonalMode(true));
    }
    if (location.search) {
      const params = new URLSearchParams(location.search);
      const queryJson: any = {};

      // Convert search params to JSON
      for (const [key, value] of params.entries()) {
        queryJson[key] = value;
      }
      setQueyrObject(queryJson)
      console.log("queryJson", queryJson);
    }

  }, []);

  useEffect(() => {
    if ((queryObject.showtutorial && queryObject.showtutorial === "true") || (queryObject.showTutorial || queryObject.showTutorial === "true")) {
      localStorage.setItem("showTutorial", "false")
      localStorage.setItem("fromUrl", "true")
      localStorage.setItem("mode", "personal")
      userTypeDispatch(isPersonalMode(true))
      userTypeDispatch(setVisibleTutorialGloabl(true))
      localStorage.setItem("tutorialStep", "1")
      userTypeDispatch(setToturialStepGlobal(1))
      navigate("/tracking")
    }
  }, [queryObject])

  useEffect(() => {
    trackingDispatch(setArchiveMode((location.state as any)?.direct || false));
  }, [(location.state as any)?.direct]);

  const width = useWidth();

  useEffect(() => {
    getUserDetails();
    getAllContacts();
    getAvailablePlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setTimeout(() => {
      console.log("ascascasc", localStorage.getItem("showTutorial") === "true", IUserTypeState.tutorialVisible, [true, "true"].includes(localStorage.getItem("showTutorial")) && !IUserTypeState.tutorialVisible);

      if ([true, "true"].includes(localStorage.getItem("showTutorial")) && !IUserTypeState.tutorialVisible) {
        if (localStorage.getItem("showPayment") === "true") {
          setVisiblePaymentFree(true)
          setPaymentStatus(PAYMENT_STATUS.ONBOARD)
          localStorage.removeItem("showPayment")
        } else {
          if (localStorage.getItem("tutorialFromSetting") === "true") {
            setVisibleTutorial(true);
            localStorage.removeItem("tutorialFromSetting")
            localStorage.setItem("showTutorial", "false")
          } else {
            userTypeDispatch(setVisibleTutorialGloabl(true))
          }
          // 
        }
      }
    }, 300);
    // setVisiblePaymentFree(true)
  }, [visibleTutorial, showFinalAnimation]);
  const getAvailablePlans = () => {
    const token = localStorage.getItem("userDetails")
    userService
      .getAllPlans(token)
      .then((data: any) => {
        console.log("data", data.data.data);
        userTypeDispatch(
          setUserProducts(data.data.data)
        );
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  }
  const getAllContacts = () => {
    contactsService
      .getContactsList(IUserTypeState.token)
      .then((data: any) => {
        const { allContact = [], groupData = [] } = data;
        contactsDispatch(setAllContacts(allContact));
        contactsDispatch(
          setGroupContacts(
            groupData.map((it) => {
              if (it.contacts && it.contacts.length) {
                it.contacts = it.contacts.map((ite) => ({
                  ...ite,
                  parent: it._id,
                }));
              }

              return it;
            })
          )
        );
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  };
  const getUserDetails = () => {
    const userId = {
      uid: IUserTypeState?.userId ? IUserTypeState?.userId : userValues?.uid,
    };
    userService
      .getUserById(userId)
      .then((data: any) => {
        console.log("getUserById data", data);

        if (data?.data?.level === "NOT_FOUND") {
          navigate("/user-identification");
        } else {
          setTimeout(() => {
            if (
              data?.data?.level === "LOW" &&
              (!data?.outcome || !data?.influence)
            ) {
              navigate("/plan-create");
            } else if (
              data?.data?.level === "HIGH" &&
              (!data?.outcome || !data?.influence || !data?.reflective)
            ) {
              navigate("/plan-create");
            }
          }, 2000);
        }
        console.log("data", data);

        setUserDetailsLoaded(true);
        userTypeDispatch(
          setUserObject({
            ...data?.data,
            showGoal: data?.showGoal,
            userSubscriptionStatus: data.userSubscriptionStatus,
            userAccountStatus: data?.userAccountStatus,
            celebrationData: data?.celebrationData,
            formatHolidayEndDate: data?.formatHolidayEndDate,
            formatHolidayStartDate: data?.formatHolidayStartDate,
            holidayMode: data?.holidayMode
          })
        );
        const queryJson: any = {};
        if (location.search) {
          const params = new URLSearchParams(location.search);
          // Convert search params to JSON
          for (const [key, value] of params.entries()) {
            queryJson[key] = value;
          }
          setQueyrObject(queryJson)
        }
        localStorage.setItem("userValues", JSON.stringify(data?.data));
        // setPaymentStatus(PAYMENT_STATUS.SUBSCRIPTION_ENDED)
        // setVisiblePaymentFree(true)
        if (!data.data.onboardedDate) {
          setPaymentStatus(PAYMENT_STATUS.ONBOARD)
          setVisiblePaymentFree(true)
        }
        // if (data.data.paymentPopup15Days && data.data.paymentPopup15Days === "VISIBLE") {
        //   setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V3)
        //   setVisiblePaymentFree(true)
        //   return
        // }

        // if (["FREE_PLAN_END"].includes(data.userSubscriptionStatus)) {
        //   setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
        //   setVisiblePaymentFree(true)
        // }
        // if (["30_DAYS_RECOVER"].includes(data.userSubscriptionStatus)) {
        //   setPaymentStatus(PAYMENT_STATUS.ACCOUNT_BLOCKED)
        //   setVisiblePaymentFree(false)
        //   userTypeDispatch(setAccountBlocked(true))
        // }
        // if (["SUBSCRIPTION_END"].includes(data.userSubscriptionStatus)) {
        //   setPaymentStatus(PAYMENT_STATUS.SUBSCRIPTION_ENDED)
        //   setVisiblePaymentFree(true)
        // }
        if (queryJson && queryJson.redirectUrl) {
          if (queryJson.redirectUrl === "paymentsuccess") {
            setPaymentStatus(PAYMENT_STATUS.PAYMENT_SUCCESS)
            setVisiblePaymentFree(true)
          }
          if (queryJson.redirectUrl === "paymentcancel") {
            setPaymentStatus(PAYMENT_STATUS.PAYMENT_FAILED)
            setVisiblePaymentFree(true)
          }
        } else {
          // setPaymentStatus(null)
        }
      })
      .catch((error) => {
        console.log("User profile Error");
      });
  };

  return (
    <>
      {!showFinalAnimation && <TracingLoader />}
      <TrackerSnackbar />

      {userDetailsLoaded && !showFinalAnimation ? (
        width > 768 ? (
          <DesktopView />
        ) : (
          <TrackingView />
          // <TrackingMobileView />
        )
      ) : (
        !showFinalAnimation && <FullpageLoader />
      )}
      {userDetailsLoaded && visiblePaymentFree && !showFinalAnimation && !IUserTypeState.hasSeenGlobalModal ? (
        <PaymentPlanInfo
          visiblePaymentInfo={visiblePaymentFree}
          onClose={() => {
            if (!subscriptionPlanEnded) {
              localStorage.removeItem("showPayment")
              setVisiblePaymentFree(false)
              if (width > 768) {
                if (localStorage.getItem("showTutorial") === "true" && !IUserTypeState.tutorialVisible) {
                  userTypeDispatch(setVisibleTutorialGloabl(true))
                }
              } else {
                if (localStorage.getItem("showTutorial") === "true" && !visibleTutorial) {
                  setVisibleTutorial(true)
                }
              }

            }
          }}
          fixClosePopup={() => {
            setVisiblePaymentFree(false)
            setSubscriptionPlanEndedBilling(true)
          }}
          closeAndOpenRestriction={() => {
            if (["30_DAYS_RECOVER"].includes(IUserTypeState.userDetails?.userSubscriptionStatus)) {
              setPaymentStatus(PAYMENT_STATUS.ACCOUNT_BLOCKED)
              setVisiblePaymentFree(false)
              userTypeDispatch(setAccountBlocked(true))
            } else {
              setPaymentStatus(PAYMENT_STATUS.FREE_COMPLETED_V2)
              setVisiblePaymentFree(true)
            }
          }}
          subscriptionPlanEndedBilling={subscriptionPlanEndedBilling}
          subscriptionPlanEnded={subscriptionPlanEnded}
          paymentStatus={paymentStatus}
        />
      ) : null}
      {userDetailsLoaded && visibleTutorial && !showFinalAnimation ? (
        <TutorialModal
          visibleTutorial={visibleTutorial}
          setVisibleTutorial={setVisibleTutorial}
          setVisibleMobileLoginModal={setVisibleMobileLoginModal}
          isMobile={width < 768}
          isFromOnboard={isFromOnboard}
        />
      ) : null}
      {userDetailsLoaded && visibleMobileLoginModal && !showFinalAnimation ? (
        <MobileLinkModal
          visibleMobileLoginModal={visibleMobileLoginModal}
          setVisibleMobileLoginModal={setVisibleMobileLoginModal}
          isMobile={width < 768}
        />
      ) : null}
      {showFinalAnimation && (
        <Grid
          container
          columns={16}
          className={width <= 768 ? "bgImageCommonMobile" : ""}
          sx={{
            backgroundColor: isDarkMode ? "var(--dark-background)" : palette.secondary.light,
            position: "absolute",
            zIndex: 99999,
            width: "100%",
            height: "100vh",
          }}
        >
          {" "}
          <Box
            sx={{
              opacity: "100%",
              zIndex: 1,
              width: "100%",
            }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                alignItems:
                  width <= 768 && !showFinalAnimation ? "flex-start" : "center",
                justifyContent: "center",
                width: "100%",
                height: "100vh",
              }}
              className="leftside-menu outcome-screen "
            >
              <FinalAnimation
                isDarkMode={isDarkMode}
                dataLoading={true}
                setShowAnimation={setShowAnimation}
              />
            </Grid>
          </Box>
        </Grid>
      )}

      <LimitReachedPopup />
      {Notification}
    </>
  );
};

export default TrackingViewNew;
